import "./App.css";
import { BrowserRouter } from "react-router-dom";
import ToastMessage from "./common/toastMessage";
import AppRoutes from "./routes/appRoutes";
import PageLoader from "./common/pageLoader";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import DashboardPageLoader from "./common/dashboardPageLoader";
import setHeaders from "./utils/setHeaders";
import keycloakService from "./modules/index";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
}
// window.addEventListener("unload", function () {
//   keycloakService.doLogout();
// });


function App() {
  useEffect(() => {
    setHeaders();
  }, []);

  return (
    <div className="App">
      {/* <BrowserRouter> */}
      <ScrollToTop />
      <ToastMessage />
      <PageLoader />
      <DashboardPageLoader />
      <AppRoutes />
      {/* </BrowserRouter> */}
    </div>
  );
}

export default App;
